import React, { useState } from 'react';
import {
  useLessonCreationState,
} from '../lessonCreation.state';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { PaymentForm } from '../../PaymentForm'; // Adjust path as needed



  
// --- Props ---
interface Step6PaymentProps {
  formId: string;
  onPaymentSuccess: (paymentIntentId: string) => void;
  onProcessingChange: (isProcessing: boolean) => void;
  onReadyChange: (isReady: boolean) => void;
}

// --- Component ---

export const Step6_Payment: React.FC<Step6PaymentProps> = ({
  formId,
  onPaymentSuccess,
  onProcessingChange,
  onReadyChange,
}) => {
  const [stripePromise] = useState(() => 
    loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!)
    );
  // Get state from the context
  const { clientSecret, totalAmount } = useLessonCreationState();

  // --- Stripe Options ---
  // 'setup' mode: we vault the card now and charge per-lesson on completion.
  const options: StripeElementsOptions = {
    mode: 'setup',
    currency: 'gbp',
    setupFutureUsage: 'off_session',
    appearance: { theme: 'stripe' },
  };

  const totalLabel = (totalAmount / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });

  // --- Render ---
  return (
    <>
      {clientSecret && stripePromise ? (
        <Elements stripe={stripePromise} options={options}>
          <div style={{
            background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '0.5rem',
            padding: '0.75rem 1rem', marginBottom: '1rem', fontSize: '0.875rem', color: '#334155',
          }}>
            <strong>You won't be charged today.</strong> We securely save your card now.
            Each lesson is charged only once your tutor marks it complete after the
            session — and you can cancel any upcoming lesson, free, before it starts.
            <div style={{ marginTop: '0.4rem', color: '#64748b' }}>
              Total if all lessons go ahead: {totalLabel}
            </div>
          </div>
          <PaymentForm
            formId={formId}
            clientSecret={clientSecret}
            onPaymentSuccess={onPaymentSuccess}
            onProcessingChange={onProcessingChange}
            onReadyChange={onReadyChange}
          />
        </Elements>
      ) : (
        // Fallback for an error state
        <div>Loading payment details...</div>
      )}
    </>
  );
};